<template>
    <div id="home" v-title :data-title="title">
        <el-container class="tech-theme-container">
            <base-header :activeIndex="activeIndex"></base-header>

            <!-- 赛博朋克玻璃风主内容区 -->
            <div class="blog-wrap tech-theme" :class="{ 'is-category-tag': isCategoryTagPage }">
                <router-view class="my-container"/>
            </div>

            <base-footer v-show="footerShow"></base-footer>
        </el-container>
    </div>
</template>

<script>
    import BaseHeader from "@/components/header/BaseHeader"
    import BaseFooter from "@/components/footer/BaseFooter"

    export default {
        name: 'Home',
        data() {
            return {
                activeIndex: '/',
                footerShow: true,
                title: "首页",
            }
        },
        components: {
            'base-header': BaseHeader,
            'base-footer': BaseFooter
        },
        computed: {
            isCategoryTagPage() {
                const p = this.$route?.path || '';
                return /^\/(category|tag)\/all$/.test(p) || /^\/archives/.test(p);
            }
        },
        /*切换header的menu，并判断底部是否显示*/
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.activeIndex = /^\/archives/.test(to.path) ? '/archives' : to.path;
                vm.footerShow = to.path === '/blog';
                vm.blurNavFocus();
            })
        },
        /*判断底部显不显示*/
        beforeRouteUpdate(to, from, next) {
            this.footerShow = to.path === '/blog';
            this.activeIndex = /^\/archives/.test(to.path) ? '/archives' : to.path;
            this.blurNavFocus();
            next()
        },
        methods: {
            /* 点击导航后移除焦点，避免出现白色 focus 样式，只保留科技风 is-active */
            blurNavFocus() {
                this.$nextTick(() => {
                    const el = document.activeElement;
                    if (el && el.closest && (el.closest('.el-menu') || el.closest('.el-tabs__nav-wrap'))) {
                        el.blur();
                    }
                });
            }
        }
    }
</script>

<style>
    .my-container {
        margin: 100px auto 56px;
        padding-bottom: 80px;
    }

    /* 赛博朋克玻璃风：深紫蓝背景 + 霓虹网格 + 扫描线 */
    .blog-wrap.tech-theme {
        flex: 1;
        min-height: calc(100vh - 60px);
        background: linear-gradient(165deg, #0a0a12 0%, #1a0a2e 25%, #0d1520 50%, #0a0a12 100%);
        position: relative;
        overflow-x: hidden;
        overflow-y: visible;
    }

    /* 分类/标签页：确保 Tab 栏及内容不被裁剪，同时减少底部留白 */
    .blog-wrap.tech-theme.is-category-tag .my-container {
        overflow: visible;
        margin-bottom: 24px;
        padding-bottom: 24px;
    }

    .blog-wrap.tech-theme::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image:
            linear-gradient(rgba(0, 255, 245, 0.04) 1px, transparent 1px),
            linear-gradient(90deg, rgba(0, 255, 245, 0.04) 1px, transparent 1px);
        background-size: 36px 36px;
        pointer-events: none;
    }

    /* 顶部霓虹分割线 */
    .blog-wrap.tech-theme {
        box-shadow: inset 0 1px 0 0 rgba(0, 255, 245, 0.25), inset 0 2px 0 0 rgba(236, 72, 153, 0.1);
    }

    .blog-wrap.tech-theme::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: repeating-linear-gradient(
            0deg,
            transparent,
            transparent 2px,
            rgba(0, 0, 0, 0.12) 2px,
            rgba(0, 0, 0, 0.12) 4px
        );
        pointer-events: none;
        animation: scanline 10s linear infinite;
    }
    @keyframes scanline {
        0% { transform: translateY(-100%); }
        100% { transform: translateY(100%); }
    }

    .blog-wrap.tech-theme .my-container {
        position: relative;
        z-index: 1;
    }

    /* 赛博朋克玻璃卡片：毛玻璃 + 青/品霓虹描边 */
    .tech-theme .el-card {
        background: rgba(10, 15, 28, 0.5) !important;
        backdrop-filter: blur(16px);
        -webkit-backdrop-filter: blur(16px);
        border: 1px solid rgba(0, 255, 245, 0.2) !important;
        border-radius: 12px !important;
        box-shadow:
            0 8px 32px rgba(0, 0, 0, 0.4),
            inset 0 1px 0 rgba(255, 255, 255, 0.06),
            0 0 0 1px rgba(236, 72, 153, 0.08) !important;
    }

    .tech-theme .el-card:hover {
        border-color: rgba(0, 255, 245, 0.45) !important;
        box-shadow:
            0 12px 40px rgba(0, 0, 0, 0.5),
            0 0 25px rgba(0, 255, 245, 0.12),
            0 0 0 1px rgba(236, 72, 153, 0.15) !important;
    }

    .tech-theme .el-card__header {
        border-bottom-color: rgba(0, 255, 245, 0.2) !important;
        color: rgba(224, 242, 254, 0.98) !important;
    }

    .tech-theme .el-card__body {
        color: rgba(203, 213, 225, 0.92) !important;
    }

    .tech-theme a {
        color: rgba(0, 255, 245, 0.95) !important;
    }

    .tech-theme a:hover {
        color: #00fff5 !important;
        text-shadow: 0 0 10px rgba(0, 255, 245, 0.5);
    }

    /* 文章标题、摘要、元信息 */
    .tech-theme .article-title,
    .tech-theme .my-article-title {
        color: rgba(224, 242, 254, 0.95) !important;
    }
    .tech-theme .article-title:hover,
    .tech-theme .my-article-title:hover {
        color: #00fff5 !important;
        text-shadow: 0 0 12px rgba(0, 255, 245, 0.4) !important;
    }
    .tech-theme .article-summary,
    .tech-theme .my-article-description {
        color: rgba(203, 213, 225, 0.85) !important;
    }
    .tech-theme .meta-item,
    .tech-theme .my-article-count,
    .tech-theme .my-article-author {
        color: rgba(148, 163, 184, 0.9) !important;
    }
    .tech-theme .article-tag,
    .tech-theme .tag-pill {
        background: rgba(0, 255, 245, 0.1) !important;
        color: #00fff5 !important;
        border: 1px solid rgba(0, 255, 245, 0.35) !important;
        box-shadow: 0 0 12px rgba(0, 255, 245, 0.15) !important;
    }
    .tech-theme .article-tag:hover,
    .tech-theme .tag-pill:hover {
        background: rgba(236, 72, 153, 0.2) !important;
        color: #fff !important;
        border-color: rgba(236, 72, 153, 0.5) !important;
        box-shadow: 0 0 15px rgba(236, 72, 153, 0.3) !important;
    }
    .tech-theme .top-badge {
        background: linear-gradient(135deg, rgba(0, 255, 245, 0.2), rgba(236, 72, 153, 0.2)) !important;
        color: #00fff5 !important;
        border: 1px solid rgba(0, 255, 245, 0.4) !important;
        box-shadow: 0 0 10px rgba(0, 255, 245, 0.25) !important;
    }

    /* 侧栏：标题、列表、归档 */
    .tech-theme .header-title,
    .tech-theme .profile-name {
        color: rgba(224, 242, 254, 0.95) !important;
    }
    .tech-theme .profile-title,
    .tech-theme .info-item,
    .tech-theme .view-more {
        color: rgba(148, 163, 184, 0.9) !important;
    }
    .tech-theme .item-title {
        color: rgba(203, 213, 225, 0.9) !important;
    }
    .tech-theme .item-title:hover {
        color: #00fff5 !important;
        text-shadow: 0 0 8px rgba(0, 255, 245, 0.35) !important;
    }
    .tech-theme .archive-date {
        color: rgba(203, 213, 225, 0.9) !important;
    }
    .tech-theme .archive-count {
        background: rgba(0, 255, 245, 0.15) !important;
        color: #00fff5 !important;
        border: 1px solid rgba(0, 255, 245, 0.25) !important;
    }
    .tech-theme .item-number {
        background: rgba(30, 30, 50, 0.8) !important;
        color: rgba(203, 213, 225, 0.9) !important;
        border: 1px solid rgba(0, 255, 245, 0.2) !important;
    }
    .tech-theme .item-number.top-three {
        background: linear-gradient(135deg, rgba(0, 255, 245, 0.25), rgba(236, 72, 153, 0.2)) !important;
        color: #00fff5 !important;
        border-color: rgba(0, 255, 245, 0.4) !important;
        box-shadow: 0 0 10px rgba(0, 255, 245, 0.2) !important;
    }

    /* 整个容器使用科技风背景，消除底部留白 */
    .tech-theme-container {
        background: linear-gradient(165deg, #0a0a12 0%, #1a0a2e 25%, #0d1520 50%, #0a0a12 100%);
        min-height: 100vh;
    }

    .tech-theme-container .el-container {
        background: transparent;
    }
</style>